import React from "react";
import VtrgCenteredImage from "../../piece_components/vtrg_centered_image/vtrg_centered_image";
import VtrgCustomBlock from "../../piece_components/vtrg_custom_block/vtrg_custom_block";
import VtrgCustomHtml from "../../piece_components/vtrg_custom_html/vtrg_custom_html";
import VtrgInnerBlock from "../../piece_components/vtrg_inner_block/vtrg_inner_block";
import VtrgJsonImg from "../../piece_components/vtrg_json_img/vtrg_json_img";
import VtrgSplitScreen from "../../piece_components/vtrg_split_screen/vtrg_split_screen";
import VtrgText from "../../piece_components/vtrg_text/vtrg_text";
import VtrgThreeColumns from "../../piece_components/vtrg_three_columns/vtrg_three_columns";
import VtrgVideo from "../../piece_components/vtrg_video/vtrg_video";
import VtrgWasBecameImage from "../../piece_components/vtrg_was_became_image/vtrg_was_became_image";
import styles from "../../../assets/styles/old_vitrage_styles.scss";

const ShowVtrgContent = ({ content }) => {
  const checkComponent = (
    ordn,
    role,
    block_params,
    instance_type,
    instance_id,
    slot
  ) => {
    const components = {
      vtrg_centered_image: VtrgCenteredImage,
      vtrg_custom_block: VtrgCustomBlock,
      vtrg_custom_html: VtrgCustomHtml,
      vtrg_inner_block: VtrgInnerBlock,
      vtrg_json_img: VtrgJsonImg,
      vtrg_split_screen: VtrgSplitScreen,
      vtrg_text: VtrgText,
      vtrg_three_columns: VtrgThreeColumns,
      vtrg_video: VtrgVideo,
      vtrg_was_became_image: VtrgWasBecameImage,
    };

    const createdTime = new Date(block_params.created_at).getTime();

    const Component = components[role];

    return (
      <Component
        key={`${block_params.id}${createdTime}`}
        data={block_params}
        instanceType={instance_type}
        instanceId={instance_id}
        pieceType={role}
        slot={slot}
        ordn={ordn}
      />
    );
  };
  const result = content ? (
    content
      .sort((a, b) => (a.ordn > b.ordn ? 1 : -1))
      .map((item) => {
        return checkComponent(
          item.ordn,
          item.type,
          item.params,
          item.parent_type,
          item.parent_id,
          item.slot
        );
      })
  ) : (
    <div />
  );

  return <div className="vtrg-main-container">{result}</div>;
};

export default ShowVtrgContent;
